var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.flags.find(function(flag) {
        return flag.field_key === "spokesperson"
      }).showField
        ? _c(
            "div",
            { staticClass: "add-contact-wrapper" },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass:
                    "add-contact-button exclude-outside-click d-inline-block",
                  attrs: { title: "Add spokesperson", disabled: true },
                  on: { click: _vm.showAddSpokesperson }
                },
                [_vm._v("Spokesperson")]
              ),
              _vm._v(" "),
              false
                ? _c("plus-button", {
                    attrs: { disabled: true },
                    on: { click: _vm.showAddSpokesperson }
                  })
                : _vm._e(),
              _vm._v(" "),
              false
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.flags.find(function(flag) {
                            return flag.field_key === "spokesperson"
                          }).toggleContactSelect,
                          expression:
                            "flags.find(flag => flag.field_key === 'spokesperson').toggleContactSelect"
                        },
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        }
                      ],
                      staticClass: "custom-multiselect",
                      attrs: { disabled: true }
                    },
                    [
                      false
                        ? _c("autocomplete", {
                            ref: "searchSpokesperson",
                            staticClass: "multiselect",
                            attrs: {
                              "debounce-time": 500,
                              search: _vm.onSpokespersonSearch,
                              placeholder:
                                "Start typing to select spokesperson",
                              "aria-label":
                                "Start typing to select spokesperson",
                              "auto-select": ""
                            },
                            on: {
                              focus: function($event) {
                                return _vm.onSpokespersonSearch(false)
                              },
                              submit: _vm.onSpokespersonSelect
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "result",
                                  fn: function(ref) {
                                    var result = ref.result
                                    var props = ref.props
                                    return [
                                      result.id == null
                                        ? _c(
                                            "li",
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "autocomplete-result contact-result multiselect__element"
                                              },
                                              "li",
                                              props,
                                              false
                                            ),
                                            [
                                              _c("div", {
                                                staticClass: "option_add",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    result.label
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      result.id
                                        ? _c(
                                            "li",
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "autocomplete-result contact-result multiselect__element"
                                              },
                                              "li",
                                              props,
                                              false
                                            ),
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "option__desc" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "option__name exclude-outside-click"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(
                                                            result.first_name
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            result.last_name
                                                          ) +
                                                          "\n                            "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "option__company exclude-outside-click"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          result.company_name
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "option__phone exclude-outside-click"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(result.phone)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1479045461
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm._.filter(_vm.deliverableDetail.customFields, {
                  field_key: "spokesperson"
                }),
                function(contact, index) {
                  return contact.value && contact.contactData
                    ? _c(
                        "div",
                        {
                          key: "spokesperson-" + index,
                          staticClass: "contact-box"
                        },
                        [
                          _c("div", { staticClass: "contact-box__name" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(contact.contactData.name) +
                                "\n                "
                            ),
                            !(
                              !_vm.userAbilities.editMediaCall ||
                              _vm.deliverableDetail.permissions.viewOnly
                            )
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass: "edit-contact-btn",
                                    attrs: {
                                      title: "Edit spokesperson",
                                      href: "#"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.updateContact(
                                          contact.contactData,
                                          "spokesperson"
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-edit" })]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          contact.contactData.position
                            ? _c(
                                "div",
                                { staticClass: "contact-box__position" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(contact.contactData.position) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.company_name
                            ? _c(
                                "div",
                                { staticClass: "contact-box__company_name" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(contact.contactData.company_name) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.phone
                            ? _c("div", { staticClass: "contact-box__phone" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.Format.hrefPhone(
                                        contact.contactData.phone
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    T: " +
                                        _vm._s(contact.contactData.phone)
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.cell_phone
                            ? _c(
                                "div",
                                { staticClass: "contact-box__cell_phone" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.Format.hrefPhone(
                                          contact.contactData.cell_phone
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    M: " +
                                          _vm._s(contact.contactData.cell_phone)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.fax
                            ? _c("div", { staticClass: "contact-box__fax" }, [
                                _vm._v(
                                  "\n                F:" +
                                    _vm._s(contact.contactData.fax) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.email_address
                            ? _c("div", { staticClass: "contact-box__email" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.Format.hrefEmail(
                                        contact.contactData.email_address
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          contact.contactData.email_address
                                        )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.website
                            ? _c(
                                "div",
                                { staticClass: "contact-box__website" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.Format.website(
                                          contact.contactData.website
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(contact.contactData.website)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.address
                            ? _c(
                                "div",
                                { staticClass: "contact-box__address" },
                                [
                                  _vm._v(
                                    _vm._s(contact.contactData.address) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.city
                            ? _c("div", { staticClass: "contact-box__city" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.Format.city(contact.contactData.city)
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.province
                            ? _c(
                                "div",
                                { staticClass: "contact-box__province" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(contact.contactData.province) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.country_id
                            ? _c(
                                "div",
                                { staticClass: "contact-box__country_id" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(contact.contactData.country_id) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.postal_code
                            ? _c(
                                "div",
                                { staticClass: "contact-box__postal_code" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.Format.postalCode(
                                          contact.contactData.postal_code
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.region
                            ? _c(
                                "div",
                                { staticClass: "contact-box__region" },
                                [
                                  _vm._v(
                                    _vm._s(contact.contactData.region) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.notes
                            ? _c("div", { staticClass: "contact-box__notes" }, [
                                _vm._v(_vm._s(contact.contactData.notes))
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                }
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.flags.find(function(flag) {
        return flag.field_key === "who"
      }).showField
        ? _c(
            "div",
            { staticClass: "add-contact-wrapper" },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass:
                    "add-contact-button exclude-outside-click d-inline-block",
                  attrs: { title: "Add contact" },
                  on: { click: _vm.showAddWho }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.deliverableContactsLabel(
                          _vm.deliverableDetail.deliverable_template_id
                        )
                      )
                  )
                ]
              ),
              _vm._v(" "),
              false
                ? _c("plus-button", { on: { click: _vm.showAddWho } })
                : _vm._e(),
              _vm._v(" "),
              false
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.flags.find(function(flag) {
                            return flag.field_key === "who"
                          }).toggleContactSelect,
                          expression:
                            "flags.find(flag => flag.field_key === 'who').toggleContactSelect"
                        },
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        }
                      ],
                      staticClass: "custom-multiselect"
                    },
                    [
                      _c("autocomplete", {
                        ref: "searchWho",
                        staticClass: "multiselect",
                        attrs: {
                          "debounce-time": 500,
                          search: _vm.onWhoSearch,
                          placeholder:
                            "Start typing to select outlet / contact",
                          "aria-label":
                            "Start typing to select outlet / contact",
                          "auto-select": ""
                        },
                        on: { submit: _vm.onWhoSelect },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "result",
                              fn: function(ref) {
                                var result = ref.result
                                var props = ref.props
                                return [
                                  result.id == null
                                    ? _c(
                                        "li",
                                        _vm._b(
                                          {
                                            staticClass:
                                              "autocomplete-result contact-result multiselect__element"
                                          },
                                          "li",
                                          props,
                                          false
                                        ),
                                        [
                                          _c("div", {
                                            staticClass: "option_add",
                                            domProps: {
                                              innerHTML: _vm._s(result.label)
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  result.id
                                    ? _c(
                                        "li",
                                        _vm._b(
                                          {
                                            staticClass:
                                              "autocomplete-result contact-result multiselect__element"
                                          },
                                          "li",
                                          props,
                                          false
                                        ),
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "option__desc" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "option__name exclude-outside-click"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        result.first_name
                                                      ) +
                                                      " " +
                                                      _vm._s(result.last_name) +
                                                      "\n                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "option__company exclude-outside-click"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(result.company_name)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "option__phone exclude-outside-click"
                                                },
                                                [_vm._v(_vm._s(result.phone))]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1479045461
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm._.filter(_vm.deliverableDetail.customFields, {
                  field_key: "who"
                }),
                function(contact, index) {
                  return contact.value && contact.contactData
                    ? _c(
                        "div",
                        { key: "who-" + index, staticClass: "contact-box" },
                        [
                          _c("div", { staticClass: "contact-box__name" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(contact.contactData.name) +
                                "\n                "
                            ),
                            !(
                              !_vm.userAbilities.editMediaCall ||
                              _vm.deliverableDetail.permissions.viewOnly
                            )
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass: "edit-contact-btn",
                                    attrs: { title: "Edit contact", href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.updateContact(
                                          contact.contactData,
                                          "who"
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-edit" })]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          contact.contactData.position
                            ? _c(
                                "div",
                                { staticClass: "contact-box__position" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(contact.contactData.position) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.company_name
                            ? _c(
                                "div",
                                { staticClass: "contact-box__company_name" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(contact.contactData.company_name) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.phone
                            ? _c("div", { staticClass: "contact-box__phone" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.Format.hrefPhone(
                                        contact.contactData.phone
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    T: " +
                                        _vm._s(contact.contactData.phone)
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.cell_phone
                            ? _c(
                                "div",
                                { staticClass: "contact-box__cell_phone" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.Format.hrefPhone(
                                          contact.contactData.cell_phone
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    M: " +
                                          _vm._s(contact.contactData.cell_phone)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.fax
                            ? _c("div", { staticClass: "contact-box__fax" }, [
                                _vm._v(
                                  "\n                F:" +
                                    _vm._s(contact.contactData.fax) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.email_address
                            ? _c("div", { staticClass: "contact-box__email" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.Format.hrefEmail(
                                        contact.contactData.email_address
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          contact.contactData.email_address
                                        )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.website
                            ? _c(
                                "div",
                                { staticClass: "contact-box__website" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.Format.website(
                                          contact.contactData.website
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(contact.contactData.website)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.address
                            ? _c(
                                "div",
                                { staticClass: "contact-box__address" },
                                [
                                  _vm._v(
                                    _vm._s(contact.contactData.address) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.city
                            ? _c("div", { staticClass: "contact-box__city" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.Format.city(contact.contactData.city)
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.province
                            ? _c(
                                "div",
                                { staticClass: "contact-box__province" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(contact.contactData.province) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.country_id
                            ? _c(
                                "div",
                                { staticClass: "contact-box__country_id" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(contact.contactData.country_id) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.postal_code
                            ? _c(
                                "div",
                                { staticClass: "contact-box__postal_code" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.Format.postalCode(
                                          contact.contactData.postal_code
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.region
                            ? _c(
                                "div",
                                { staticClass: "contact-box__region" },
                                [
                                  _vm._v(
                                    _vm._s(contact.contactData.region) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          contact.contactData.notes
                            ? _c("div", { staticClass: "contact-box__notes" }, [
                                _vm._v(_vm._s(contact.contactData.notes))
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                }
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filteredFlags, function(flag) {
        return _c("div", { key: flag.field_key }, [
          _vm.flags.find(function(f) {
            return f.field_key === flag.field_key
          }).showField
            ? _c(
                "div",
                { staticClass: "add-contact-wrapper" },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true }
                        }
                      ],
                      staticClass:
                        "add-contact-button exclude-outside-click d-inline-block",
                      attrs: { title: "Add " + flag.label },
                      on: {
                        click: function($event) {
                          return _vm.showAddCfContact(flag.field_key)
                        }
                      }
                    },
                    [_vm._v("\n                " + _vm._s(flag.label))]
                  ),
                  _vm._v(" "),
                  _c("plus-button", {
                    attrs: { title: "Add " + flag.label },
                    on: {
                      click: function($event) {
                        return _vm.showAddCfContact(flag.field_key)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.flags.find(function(f) {
                            return f.field_key === flag.field_key
                          }).toggleContactSelect,
                          expression:
                            "flags.find(f => f.field_key === flag.field_key).toggleContactSelect"
                        },
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        }
                      ],
                      staticClass: "custom-multiselect"
                    },
                    [
                      _c("autocomplete", {
                        ref: "search-" + flag.field_key,
                        refInFor: true,
                        staticClass: "multiselect",
                        attrs: {
                          "debounce-time": 500,
                          search: _vm.onCfContactSearch,
                          placeholder: "Start typing to select contact",
                          "aria-label": "Start typing to select contact",
                          "auto-select": ""
                        },
                        on: { submit: _vm.onCfContactSelect },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "result",
                              fn: function(ref) {
                                var result = ref.result
                                var props = ref.props
                                return [
                                  result.id == null
                                    ? _c(
                                        "li",
                                        _vm._b(
                                          {
                                            staticClass:
                                              "autocomplete-result contact-result multiselect__element"
                                          },
                                          "li",
                                          props,
                                          false
                                        ),
                                        [
                                          _c("div", {
                                            staticClass: "option_add",
                                            domProps: {
                                              innerHTML: _vm._s(result.label)
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  result.id
                                    ? _c(
                                        "li",
                                        _vm._b(
                                          {
                                            staticClass:
                                              "autocomplete-result contact-result multiselect__element"
                                          },
                                          "li",
                                          props,
                                          false
                                        ),
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "option__desc" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "option__name exclude-outside-click"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        result.first_name
                                                      ) +
                                                      " " +
                                                      _vm._s(result.last_name) +
                                                      "\n                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "option__company exclude-outside-click"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(result.company_name)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "option__phone exclude-outside-click"
                                                },
                                                [_vm._v(_vm._s(result.phone))]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm._.filter(_vm.filteredContactList, {
                      field_key: flag.field_key
                    }),
                    function(contact, index) {
                      return contact.value && contact.contactData
                        ? _c(
                            "div",
                            {
                              key: flag.field_key + "-" + index,
                              staticClass: "contact-box"
                            },
                            [
                              _c("div", { staticClass: "contact-box__name" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(contact.contactData.name) +
                                    "\n                    "
                                ),
                                !(
                                  !_vm.userAbilities.editMediaCall ||
                                  _vm.deliverableDetail.permissions.viewOnly
                                )
                                  ? _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass: "edit-contact-btn",
                                        attrs: {
                                          title: "Edit " + flag.label,
                                          href: "#"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.updateCfContact(
                                              contact.contactData,
                                              contact.children,
                                              flag.field_key
                                            )
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fas fa-edit" })]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              contact.contactData.position
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__position" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(contact.contactData.position) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.company_name
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "contact-box__company_name"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            contact.contactData.company_name
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.phone
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__phone" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.Format.hrefPhone(
                                              contact.contactData.phone
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        T: " +
                                              _vm._s(contact.contactData.phone)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.cell_phone
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__cell_phone" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.Format.hrefPhone(
                                              contact.contactData.cell_phone
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        M: " +
                                              _vm._s(
                                                contact.contactData.cell_phone
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.fax
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__fax" },
                                    [
                                      _vm._v(
                                        "\n                    F:" +
                                          _vm._s(contact.contactData.fax) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.email_address
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__email" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.Format.hrefEmail(
                                              contact.contactData.email_address
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                contact.contactData
                                                  .email_address
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.website
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__website" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.Format.website(
                                              contact.contactData.website
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(contact.contactData.website)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.address
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__address" },
                                    [
                                      _vm._v(
                                        _vm._s(contact.contactData.address) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.city
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__city" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.Format.city(
                                              contact.contactData.city
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.province
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__province" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(contact.contactData.province) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.country_id
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__country_id" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            contact.contactData.country_id
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.postal_code
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__postal_code" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.Format.postalCode(
                                              contact.contactData.postal_code
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.region
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__region" },
                                    [
                                      _vm._v(
                                        _vm._s(contact.contactData.region) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              contact.contactData.notes
                                ? _c(
                                    "div",
                                    { staticClass: "contact-box__notes" },
                                    [
                                      _vm._v(
                                        _vm._s(contact.contactData.notes) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    }
                  )
                ],
                2
              )
            : _vm._e()
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }